import RateLimitResponse from "assets/images/swaggerRateLimitedResponse.webp";
import { StyledBody } from "components/apiDocs/BrowseAllPage/style";
import { DownloadButttonWrapper } from "components/apiDocs/GettingStartedPage/style";
import Button from "components/components/Button/Button";
import { SwaggerJsonFile } from "models/apiDocumentation/apiDocumentationModels";
import React from "react";
import { buildJsonBlobForDownload } from "utils/DataDownloads/ExportDataToFile";

interface Props {
  downloadData: SwaggerJsonFile | null;
}
const GuidancePage: React.FC<Props> = ({ downloadData }) => {
  return (
    <StyledBody className="guidance">
      <h1>API Guidance</h1>
      <h2>API Patterns</h2>
      <p>
        <b>Dataset Endpoints</b> – An API suite providing data published as
        received from the Data Provider (e.g. National Grid ESO).
      </p>
      <p>
        The dataset endpoints allow the user to request data based on published
        times, allowing retrieval of superseded data such as historical
        forecasts or to back-fill archive data; data will be returned in CSV,
        XML or JSON and will be suitable for market domain experts.
      </p>
      <p>
        <b>Opinionated API Endpoints</b> – These are a series endpoints derived
        from each dataset designed to help users answer specific questions from
        the data provided.
      </p>
      <p>For example:</p>
      <ul>
        <li>
          <p>
            /forecast/demand/daily/evolution... will provide the evolution of
            all daily demand forecasts over time for a given forecast date.
          </p>
        </li>
        <li>
          <p>
            /forecast/generation/wind/latest... will provide the latest wind
            forecast MW for a specific point in time which changes with each new
            published file.
          </p>
        </li>
      </ul>
      <p>
        <b>Streaming Endpoints</b> – The Stream endpoints are minimal APIs
        architected based on ASP.NET Core 6.0 returning efficient JSON files.
        These are no restrictions or limits on data return and will be available
        for most Dataset endpoints and some Opinionated endpoints. Response
        format is JSON only.
      </p>
      <p>
        <b>Summary data</b> (e.g. /forecast/availability/weekly…) – An API suite
        that are summary endpoints containing aggregated data for data
        visualisation purposes and will lack the granularity and resolution for
        data users.
      </p>
      <h2>Rate limiting</h2>
      <p>
        The Insights API has rate limiting enabled at 1000 requests per IP
        address per minute. Any requests made beyond this limit may result in a
        429 error (&quot;Too Many Requests&quot;) as can be seen below.
      </p>
      <img
        src={RateLimitResponse}
        alt={`An example of an Insights API response with a 429 "Too Many Requests" error`}
      />
      <p>
        For any questions on rate limiting, please contact{" "}
        <a href="mailto:insightssupport@elexon.co.uk" className="is-link">
          insightssupport@elexon.co.uk
        </a>
        .
      </p>
      <DownloadButttonWrapper>
        <Button
          buttonText="Download API Definition"
          onClick={(): void =>
            buildJsonBlobForDownload(
              [downloadData],
              `API-metadata-${new Date().toISOString()}`
            )
          }
        />
      </DownloadButttonWrapper>
    </StyledBody>
  );
};

export default GuidancePage;
